import React, {Component} from 'react';

class Input extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {
        this.props.hanldeChange(e)
    }

    render() {
        let input = (<>
            <input type={this.props.type ? this.props.type : 'text'}
                   className={(this.props.className ? this.props.className : 'form-control base-input' ) + (this.props.error ? ' is-invalid' : '')}
                   name={this.props.name}
                   placeholder={this.props.placeholder ? this.props.placeholder : ''}
                   onChange={this.handleChange}
                   defaultValue={this.props.value}
                   readOnly={this.props.readonly}
                   autoFocus={this.props.autoFocus}
            />
            {
                this.props.error ? (
                    <div className="invalid-feedback">{this.props.error}</div>
                ) : ('')
            }
        </>);

        return (
            <>
                {
                    this.props.label ? (
                        <h2>{this.props.label}</h2>
                    ) : ('')
                }
                {
                    this.props.formGroup === undefined || this.props.formGroup ? (
                        <div className="form-group mb-4">
                            {input}
                        </div>
                    ) : (
                        input
                    )
                }
            </>
        )
    }
}

export default Input;